import { render, staticRenderFns } from "./StudentCommunityProfileView.vue?vue&type=template&id=f989c996&scoped=true&"
import script from "./StudentCommunityProfileView.vue?vue&type=script&lang=js&"
export * from "./StudentCommunityProfileView.vue?vue&type=script&lang=js&"
import style0 from "./StudentCommunityProfileView.vue?vue&type=style&index=0&id=f989c996&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f989c996",
  null
  
)

export default component.exports